var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.66926 .74303 -.62455 .78098 18 17)",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "square",
    d: "M1.5-1.5h17.091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.66926 .74303 .62455 .78098 32.999 17.072)",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "square",
    d: "M1.5-1.5h17.091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClose2);
export default __webpack_public_path__ + "static/media/icons-close2.5b85ecf17885e3cbd117c2076847bcb7.svg";
export { ForwardRef as ReactComponent };